// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__94Iii","tabsBox":"styles_tabsBox__3ekFb","createButton":"styles_createButton__3Ys7P"};